import CloudCalculator from './CloudCalculator';

export default CloudCalculator;
